module.exports = __webpack_public_path__ + "img/magnum-daily.8fbb224b.svg";